import * as styles from './agree-to-terms-input.css';

import { InputFieldData, InputStateProps } from '../../@types/input-field-data';
import CheckboxInput from './checkbox-input';

export interface AgreeToTermsInputProps extends InputStateProps, InputFieldData {
  type: 'agree_to_terms';
}

/** A component for rendering an input to collect the user's acceptance to the TOU. */
function AgreeToTermsInput(props: AgreeToTermsInputProps) {
  return (
    <CheckboxInput {...props} name={props.name || 'dialer_consent_accepted'} type="checkbox">
      I agree to the
      <a className={styles.termsOfUseLink} href="/terms-of-use">
        Terms of Use
      </a>
    </CheckboxInput>
  );
}

export default AgreeToTermsInput;
